import { Column } from '@repo/ui/data-table'
import Typography from '@repo/ui/typography'

import { TripProperties } from '../../lib/types/models/trip/properties.trip'
import { TripGrouping } from '../../lib/types/models/trip-grouping/trip-grouping'

type TripGroupingVersion = 'DENSE' | 'SUMMARY' | 'BASIC' | 'SIMPLE'

export const tripGroupingColumns: () => (Column<TripGrouping> & {
  version: TripGroupingVersion[]
})[] = () => [
  {
    version: ['DENSE', 'BASIC', 'SUMMARY', 'SIMPLE'],
    accessorKey: 'name',
    header: 'Nom du groupe',
    enableSorting: true,
    cell: ({ row }) => row.original.name
  },
  {
    version: ['DENSE', 'BASIC', 'SUMMARY', 'SIMPLE'],
    accessorKey: 'year',
    header: 'Année',
    enableSorting: true,
    cell: ({ row }) => row.original.year
  },
  {
    version: ['SIMPLE'],
    accessorKey: 'trips',
    header: 'Lieux de départ',
    cell: ({ row }) => (
      <Typography variant={'label-medium'} className="text-wrap py-2">
        {row.original.trips.length === 0
          ? '-'
          : row.original.trips
              .map((trip) => TripProperties.getDepartureOrJourneyPlaceLabel(trip))
              .filter((label): label is string => !!label)
              .sort((a, b) => a.localeCompare(b))
              .join(', ')}
      </Typography>
    )
  },
  {
    version: ['DENSE'],
    accessorKey: 'trips',
    header: 'Lieux de départ',
    cell: ({ row }) => (
      <Typography variant={'label-medium'} className="text-wrap">
        {row.original.trips.length === 0
          ? '-'
          : row.original.trips.map((trip) => TripProperties.getTripLabel(trip)).join(', ')}
      </Typography>
    )
  },
  {
    version: ['BASIC'],
    accessorKey: 'id',
    header: 'ID',
    enableSorting: true,
    cell: ({ row }) => row.original.id
  }
]

export const getTripGroupingColumns = (version: TripGroupingVersion): Column<TripGrouping>[] => {
  const columns = tripGroupingColumns()

  return columns.filter((column) => column.version.includes(version))
}
